import styled from "@emotion/styled";

// Container component
interface ContainerProps {
  wide?: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  gap: 0.5rem;

  ${(props) =>
    !props.wide &&
    `
    @media (min-width: 576px) {
      max-width: 540px;
    }
    @media (min-width: 768px) {
      max-width: 720px;
    }
    @media (min-width: 992px) {
      max-width: 960px;
    }
    @media (min-width: 1200px) {
      max-width: 1140px;
    }
  `}
`;

// Row component
export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 0.5rem;
`;

// Col component
export const Col = styled.div`
  position: relative;
  flex: 1;
`;
